import { useEffect, useState } from 'react';
import { Button, Link } from '@mui/material';
import CommonListTable, { CommonListColumn } from '../Common/CommonListTable';
import { CustomerService } from '../../services/CustomerService';
import HouseService from '../../services/HouseService';
import { CustomButton } from '../OneMealService/OneMealServiceShow';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from '../Common/CustomSnackBar';
import { useRefresh } from 'react-admin';

interface InputProps {
    customerId: number;
}

const customerService = new CustomerService();
const houseService = new HouseService();

const CustomerHouseTab = ({ customerId }: InputProps) => {
    const refresh = useRefresh();
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const refreshData = () => {
        setLoading(true);
        customerService
            .getAllHouseForCustomer(customerId)
            .then((res: any) => {
                setData(res?.data ?? []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    useEffect(() => {
        refreshData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId]);

    const columns: CommonListColumn[] = [
        { label: 'Id', field: 'id' },
        { label: 'Address', render: (row) => row?.fullAddress || '-' },
        { label: 'Locality', field: 'locality' },
        { label: 'Mobile', field: 'mobile' },
        { label: 'City', field: 'city' },
        { label: 'lat', field: 'lat' },
        { label: 'long', field: 'long' },
        {
            label: 'Actions',
            stopRowClick: true,
            render: (row) => (
                <div style={{ display: 'flex', gap: 8 }}>
                    <Link href={`/#/Houses/${row.id}/show`}>
                        <Button variant="contained" color="primary" size="small">Show</Button>
                    </Link>
                    <CustomButton
                        name="Delete"
                        color="error"
                        callback={() => {
                            EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                                message: 'Confirm deletion of house?',
                                onClose: (confirmed: boolean) => {
                                    if (confirmed) {
                                        houseService
                                            .deleteHouse(row?.id, customerId)
                                            .then(() => {
                                                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                                                    message: 'Marked Successfully',
                                                    type: CustomSnackbarTypes.SUCCESS,
                                                });
                                                refresh();
                                            });
                                    }
                                },
                                title: 'Confirmation',
                            });
                        }}
                    />
                </div>
            ),
        },
    ];

    return (
        <CommonListTable
            columns={columns}
            data={data}
            loading={loading}
            emptyText="No House Found"
        />
    );
};

export default CustomerHouseTab;
